import { Box } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

export const Content = styled(Box)`
  width: 600px;

  @media (max-width: 1345px) {
    width: 500px;
  }

  @media (max-width: 992px) {
    width: 100%;
  }

  @media (max-width: 568px) {
    margin-bottom: 80px;
  }

  @media (max-width: 480px) {
    bottom: -15px;
  }

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
      flex-grow: 1;
    `}

  ${(props) =>
    props.isMarginCenter &&
    css`
      margin: 0 auto;
    `}

  ${(props) =>
    props.isFlexCenter &&
    css`
      justify-content: center;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isAnalytics &&
    css`
      width: 78%;
    `}

  ${(props) =>
    props.isOpenProduct &&
    css`
      width: initial;
      flex-grow: 1;
    `}
`;

export const ContentMenu = styled(Box)`
  display: none;
  width: 630px;

  justify-content: space-between;

  @media (max-width: 1345px) {
    width: 500px;
  }

  @media (max-width: 992px) {
    width: auto;
  }

  @media (max-width: 568px) {
    position: fixed;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    margin: 0 0 0 -15px;
    padding: 5px 0;
    background: var(--main-background);
    border-top: 1px solid rgb(230, 230, 232);
  }

  @media (max-width: 480px) {
    bottom: -15px;
  }

  ${(props) =>
    props.actionMenu &&
    css`
      width: auto;
      margin: 0 0 28px 0;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.audienceMenu &&
    css`
      margin: 18px 22px 28px 0;
      justify-content: flex-start;
      align-items: center;
      width: auto;

      @media (max-width: 568px) {
        position: static;
        bottom: 0;
        z-index: 0;
        width: 100%;
        margin: 18px 22px 28px 0;
        padding: 0;
        background: transparent;
        border-top: none;
      }
    `}

  ${(props) =>
    props.buttonLink &&
    css`
      margin: 18px 22px 28px 0;
      justify-content: flex-start;
      align-items: center;
      width: 360px;

      @media (max-width: 768px) {
        position: static;
        bottom: 0;
        z-index: 0;
        width: 100%;
        margin: 0 auto 20px;
        padding: 0;
        background: transparent;
        border-top: none;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Instructions = styled(Box)`
  cursor: pointer;
  text-decoration: underline;
  color: #007aff;
`;

export const ContentItem = styled(Box)`
  position: relative;
  width: 50%;
  text-align: center;
  cursor: pointer;

  @media (max-width: 568px) {
    margin-bottom: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--subtle-background);

    @media (max-width: 568px) {
      display: none;
    }
  }

  ${(props) =>
    props.active &&
    css`
      font-weight: bold;

      @media (max-width: 568px) {
        font-weight: 400;
      }

      &:after {
        background: #616161;

        @media (max-width: 568px) {
          bottom: -11px;
          left: 50%;
          right: 50%;
          width: 75%;
          height: 5px;
          margin: 0 auto;
          display: block;
          transform: translate(-50%, -50%);
          background: #7954e0;
          border-radius: 18px;
        }
      }
    `}

  ${(props) =>
    props.actionItem &&
    css`
      width: 33.33%;
    `}

   ${(props) =>
    props.order &&
    css`
      order: ${props.order};
    `}

   ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.WebsiteMenuItem &&
    css`
      width: 20%;

      &:after {
        @media (max-width: 568px) {
          display: block;
        }
      }

      @media (max-width: 568px) {
        font-size: 14px;
      }
    `}

   ${(props) =>
    props.active &&
    props.WebsiteMenuItem &&
    css`
      &:after {
        @media (max-width: 568px) {
          background: #ffbc49;
        }
      }
    `}

   ${(props) =>
    props.buttonLink &&
    css`
      width: 50%;

      &:after {
        @media (max-width: 568px) {
          display: block;
        }
      }
    `}

   ${(props) =>
    props.productItem &&
    css`
      width: auto;
      margin-right: 10px;
      padding: 10px 18px;
      cursor: pointer;
      color: var(--main-black);

      &:after {
        display: none;
      }
    `}

   ${(props) =>
    props.productActiveItem &&
    css`
      font-weight: bold;
      background: #f8f2e7;
      border-radius: 8px;
    `}

   ${(props) =>
    props.page &&
    css`
      font-weight: bold;
      align-items: center;
      display: flex;
      justify-content: flex-start;

      @media (max-width: 576px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 16px;
        font-size: 18px;
      }

      &:after {
        display: none;
      }
    `}
`;

export const ContentIconBox = styled(Box)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
`;

export const ContentIcon = styled.img`
  margin-left: 10px;
  width: 17px;
  height: 17px;

  ${(props) =>
    props.arrow &&
    css`
      width: 14px;
      height: 14px;
    `}

  ${(props) =>
    props.rotate &&
    css`
      transform: rotate(180deg);
    `}
`;

export const ContentBackIcon = styled.img`
  margin-right: 28px;
  width: 30px;
  height: 30px;
  transform: rotate(180deg);
  cursor: pointer;

  ${(props) =>
    props.isHideDesktop &&
    css`
      @media (min-width: 992px) {
        display: none;
      }
    `}

  ${(props) =>
    props.backButtonLink &&
    css`
      position: absolute;
      top: 18px;
      left: 23px;
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.WebsiteMenuItem &&
    css`
      @media (max-width: 568px) {
        left: 10px;
        position: absolute;
        top: -50px;
      }
    `}

     ${({ width }) =>
    width &&
    css`
       {
       width: ${width};
      }
    `}

     ${({ height }) =>
    height &&
    css`
      {
       height: ${height};
      }
    `}

     ${({ margin }) =>
    margin &&
    css`
      {
       margin: ${margin};
      }
    `}

       ${({ top }) =>
    top &&
    css`
      {
       top: ${top};
      }
    `}
`;

export const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ${(props) =>
    props.isPagesBlock &&
    css`
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: start;
    `}
`;

export const WebsiteBox = styled(Box)`
  display: flex;
  justify-content: space-evenly;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const WebsiteContent = styled(Box)`
  position: relative;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const ContentDashboard = styled(Box)`
  display: none;
  position: relative;
  width: 630px;
  margin: 0;

  @media (max-width: 1345px) {
    width: 500px;
    min-width: 500px;
  }

  @media (max-width: 992px) {
    min-width: 480px;
  }

  @media (max-width: 576px) {
    margin: 0;
    width: initial;
    min-width: initial;
  }

  @media (max-width: 480px) {
    margin-bottom: 100px;
    width: 100%;
  }

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isOpenProduct &&
    css`
      margin: 0 0 0 35px;
      width: initial;
    `}

  ${(props) =>
    props.isAddBlockFixed &&
    css`
      margin-bottom: 80px;
      padding-bottom: 20px;
    `}



  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const ContentPageBox = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.flexColumn &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

      ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const ContentPageBoxItem = styled(Box)`
  @media (max-width: 568px) {
    width: 48%;
    flex: none;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.hiddenResultAction &&
    css`
      width: 100% !important;
    `}

  ${(props) =>
    props.activeButton &&
    css`
      @media (max-width: 568px) {
        width: 100% !important;
      }
    `}
`;

export const ContentMenuList = styled(Box)`
  display: none;

  @media (max-width: 480px) {
    margin-bottom: 80px;
  }

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}
`;

export const ContentMenuItemHeader = styled(Box)`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.title &&
    css`
      font-size: 22px;
    `}
`;

export const ContentMenuItemTitle = styled(Box)`
  font-size: 20px;
  color: var(--main-black);
`;

export const ContentMenuCaption = styled(Box)``;

export const ContentMenuCaptionText = styled.span`
  position: relative;
  font-size: 14px;
  font-weight: bold;
  color: var(--main-black);

  ${(props) =>
    props.isNotPro &&
    css`
      &:after {
        content: 'PRO';
        position: absolute;
        top: 50%;
        left: calc(100% + 6px);
        transform: translateY(-50%);
        height: 16px;
        background: #17ce17;
        font-size: 9px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        line-height: 16px;
        border-radius: 20px;
        padding: 0 8px;
        white-space: nowrap;
      }
    `}
`;

export const ContentMenuSubcaption = styled(Box)`
  font-size: 12px;
  color: var(--secondary-gray);
`;

export const ContentMenuIcon = styled.img`
  width: 12px;
  transform: rotate(-90deg);

  [data-theme='dark'] & {
    filter: invert(1);
  }
`;

export const IconButtonZapier = styled.img`
  margin-top: -4px;
  width: 64px;
  height: 30px;
  margin-left: 4px;
`;

export const ContentTitleBox = styled(Box)`
  position: absolute;
  top: -110px;
  width: 100%;
  height: 80px;
  padding-left: 3rem;
  padding-top: 20px;
  font-size: 30px;
  border-bottom: 1px solid rgb(230, 230, 232);

  @media (max-width: 480px) {
    position: static;
    padding-left: 0;
    padding-top: 0;
    border-top: 1px solid rgb(230, 230, 232);
    height: auto;
  }
  // @media (max-width: 992px) {
  //   display: none;
  // }

  ${(props) =>
    props.top &&
    css`
      top: ${props.top};
    `}

  ${(props) =>
    props.isMenu &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: center;
    `}
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.isMenu &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: center;
    `}
  ${(props) =>
    props.isEmail &&
    css`
      padding: 36px 0 0;
      display: flex;
      justify-content: start;
      width: 80%;
    `}


  ${(props) =>
    props.isSectionMenu &&
    css`
      width: auto;
    `}

  ${(props) =>
    props.isStatic &&
    css`
      position: static;
    `}
`;

export const WebsiteMenu = styled(Box)`
  margin-left: -70px;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  line-height: normal;
  width: 600px;
  gap: 1.5rem;

  @media (max-width: 576px) {
    justify-content: space-between;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 0 32px;
  }

  ${(props) =>
    props.isFixedMenu &&
    css`
      width: 100%;
      margin-left: 302px;
    `}

  ${(props) =>
    props.isAudienceMenu &&
    css`
      position: absolute;
      top: -75px;
      margin-left: -70px;
      width: fit-content;
      height: 45px;
      border-bottom: 1px solid rgb(230, 230, 232);
      width: 80%;
      padding-left: 70px;

      @media (max-width: 480px) {
        width: 100%;
        margin-left: 0;
        top: 0;
        flex-direction: column;
        background: var(--main-background);
        justify-content: flex-start;
      }
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}
  ${(props) =>
    props.isProduct &&
    css`
      width: initial;
      margin: 0 0 32px;
      border-bottom: 1px solid rgb(230, 230, 232);
    `}

  ${(props) =>
    props.isMenu &&
    css`
      gap: 0.5rem;
      border-bottom: none;
    `}

  ${(props) =>
    props.isEmailMenu &&
    css`
      margin-left: 20px;
    `}
`;

export const ContentImage = styled.img`
  width: 100%;
  display: block;
  margin: 0 auto;
`;

export const ContentProBox = styled(Box)`
  display: none;
  justify-content: center;
  margin-top: 150px;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
      @media (max-width: 480px) {
        flex-direction: column-reverse;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isList &&
    css`
      justify-content: flex-start;
      margin-left: 50px;
      @media (max-width: 480px) {
        margin-left: 0;
      }
    `}
`;

export const ContentProPromo = styled(Box)`
  width: 340px;
  margin-top: 40px;
  margin-right: 60px;
  padding: 0 0 60px;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    width: 100%;
    margin-top: 16px;
    margin-right: 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ${(props) =>
    props.promotion &&
    css`
      width: 410px;
    `}
`;

export const ContentProTitle = styled(Box)`
  font-weight: 600;
  font-size: 30px;
  line-height: 1.2;

  ${(props) =>
    props.promotion &&
    css`
      font-size: 34px;
    `}
`;

export const ContentProText = styled(Box)`
  margin: 18px 0 30px 0;
  font-size: 18px;
  line-height: 1.5;
  color: var(--main-black);
  @media (max-width: 480px) {
    text-align: justify;
  }
`;

export const ContentProImageBox = styled(Box)`
  width: 330px;
  height: 400px;

  ${(props) =>
    props.promotion &&
    css`
      margin-top: -100px;
      width: 500px;
      height: 450px;
    `}

  ${(props) =>
    props.wallet &&
    css`
      margin-top: -100px;
      width: 500px;
      height: auto;

      @media (max-width: 480px) {
        width: 100vw;
        height: auto;
      }
    `}
`;
